import {
    buildCapabilityFinancePartnerDisplayNames,
    filterFinancePartnerMasterListByAllowList,
} from '../../services/oneButtonServices/capabilityService';
import masterServices from '../../services/oneButtonServices/masterServices';
import { COMMON_CONSTANTS, useOneButtonStore } from '../../store/oneButtonStore';
import { hydrateOpportunityStore } from './preContractTitle';

/**
 * Pre-contract does not mount OpportunityDetailsCard, so finance hub master lists
 * must be loaded before ProductsFinanceHub rows can offer partner/method options.
 */
export async function ensurePreContractProductsHubReady(salesForceId: string): Promise<void> {
    const sfid = String(salesForceId ?? '').trim();
    if (!sfid) return;

    const store = useOneButtonStore.getState();
    store.setSalesForceId(sfid);

    if (!store.opportunityDetails) {
        await hydrateOpportunityStore(sfid);
    }

    const hasMasterLists =
        (store.productTypeList?.length ?? 0) > 0 &&
        (store.financePartnersList?.length ?? 0) > 0;
    if (hasMasterLists) return;

    await store.fetchOnebuttonCapabilities(false);
    const caps = useOneButtonStore.getState().onebuttonCapabilities;

    const res = await masterServices.GetMasterDataByStep({
        step: 1,
        paramDTOs: [{ key: 'string', value: 'string' }],
    });
    const data = res?.data || res;
    store.setOpportunityinfoMasterData(data);

    if (data?.ProductType && Array.isArray(data.ProductType)) {
        const productsList: Array<{ Text: string; Value?: string | number }> = [];
        data.ProductType.forEach((ele: { Text?: string; Value?: string | number }) => {
            if (
                ele.Text === COMMON_CONSTANTS.SolarProductName ||
                ele.Text === COMMON_CONSTANTS.BatteryProductName ||
                ele.Text === COMMON_CONSTANTS.RoofProductName ||
                ele.Text === COMMON_CONSTANTS.RRRProductName ||
                ele.Text === COMMON_CONSTANTS.RRProduct
            ) {
                productsList.push(ele);
            }
        });
        store.setProductTypeList(productsList);
    }

    const rawPartners = data?.FinancePartnerName;
    if (Array.isArray(rawPartners)) {
        let list: typeof rawPartners = rawPartners;
        if (caps?.capabilities) {
            const allowed = buildCapabilityFinancePartnerDisplayNames(caps);
            list =
                allowed.length > 0
                    ? filterFinancePartnerMasterListByAllowList(rawPartners, allowed)
                    : [];
        }
        store.setFinancePartnersList(list);
    } else {
        store.setFinancePartnersList([]);
    }
}
